'use client';

import { useEffect, useState } from 'react';
import { Button } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { primaryColor } from '@/src/styles/colors';

const COOKIE_NAME = 'ga_consent'; // "granted" | "denied"

function setConsentCookie(value: 'granted' | 'denied') {
    // 6 months
    const maxAge = 60 * 60 * 24 * 183;
    document.cookie = `${COOKIE_NAME}=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}

function getCookie(name: string) {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split('=')[1]) : null;
}

export default function rCookieBanner() {
    const dictionary = useDictionary();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const current = getCookie(COOKIE_NAME);
        if (!current) setShow(true);
    }, []);

    if (!show) return null;

    return (
        <div
            style={{
                position: 'fixed',
                inset: 'auto 1rem 1rem 1rem',
                zIndex: 9999,
                background: 'rgba(20,20,20,0.9)',
                backdropFilter: 'blur(6px)',
                color: 'white',
                padding: '1rem',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            }}
            role="dialog"
            aria-live="polite"
            aria-labelledby="cookie-dialog-title"
        >
            <h2 id="cookie-dialog-title" style={{ fontSize: '1.2rem', margin: 0, marginBottom: '0.5rem' }}>
                {dictionary.general.cookieTitle}
            </h2>
            <p style={{ margin: 0, marginBottom: '0.75rem', lineHeight: 1.4 }}>{dictionary.general.cookie}</p>
            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                <Button
                    variant="default"
                    onClick={() => {
                        setConsentCookie('denied');
                        setShow(false);
                        // Optional: force refresh so the server layout re-renders without GA
                        window.location.reload();
                    }}
                >
                    {dictionary.general.accept}
                </Button>
                <Button
                    color={primaryColor}
                    onClick={() => {
                        setConsentCookie('granted');
                        setShow(false);
                        window.location.reload();
                    }}
                >
                    {dictionary.general.deny}
                </Button>
            </div>
        </div>
    );
}
